import { render, staticRenderFns } from "./OtherLocale.vue?vue&type=template&id=012abb08&scoped=true"
import script from "./OtherLocale.vue?vue&type=script&lang=js"
export * from "./OtherLocale.vue?vue&type=script&lang=js"
import style0 from "./OtherLocale.vue?vue&type=style&index=0&id=012abb08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012abb08",
  null
  
)

export default component.exports